import actions from './en-US/actions';
import admin from './en-US/admin';
import common from './en-US/common';
import error from './en-US/error';
import features from './en-US/features';
import form from './en-US/form';
import menu from './en-US/menu';
import messages from './en-US/messages';
import price from './en-US/price';
import scheduler from './en-US/scheduler';
import subscriptions from './en-US/subscriptions';
import table from './en-US/table';
import tenants from './en-US/tenants';

export default {
  ...actions,
  ...admin,
  ...common,
  ...error,
  ...form,
  ...menu,
  ...features,
  ...messages,
  ...price,
  ...table,
  ...tenants,
  ...subscriptions,
  ...scheduler,
};
